import { DataProvider } from 'ra-core';
import { getNextRef } from '../documents/shared/documentReference';

/** Creates an Opportunity for an Enquiry that has reached "in_discussion" or
 * "qualified" (skipping the earlier stage is fine — e.g. Lead conversion
 * marks the Enquiry Qualified directly), unless one already exists. */
export const ensureOpportunityForEnquiry = async (
    dataProvider: DataProvider,
    enquiry: { id: number | string; company_id?: number | string; contact_id?: number | string; requirements?: any },
): Promise<boolean> => {
    const { data: existingOpps } = await dataProvider.getList('opportunities', {
        pagination: { page: 1, perPage: 1 },
        sort: { field: 'id', order: 'ASC' },
        filter: { enquiry_id: enquiry.id },
    });
    if (existingOpps.length > 0) return false;

    const { data: allOpps } = await dataProvider.getList('opportunities', {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'id', order: 'DESC' },
        filter: {},
    });
    const nextRef = getNextRef('opportunity', allOpps.map((o: any) => o.reference).filter(Boolean));

    await dataProvider.create('opportunities', {
        data: {
            reference: nextRef,
            enquiry_id: enquiry.id,
            company_id: enquiry.company_id,
            contact_id: enquiry.contact_id,
            stage: 'requirement_discussion',
            status: 'open',
            deal_value: enquiry.requirements?.estimated_budget || enquiry.requirements?.budget_min || 0,
        },
    });
    return true;
};
